import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';

class Content extends Component {
    render() {
        const { className, backgroundColor, children } = this.props;

        return (
            <Root backgroundColor={backgroundColor}>
                <ContentContainer className={className}>
                    {children}
                </ContentContainer>
            </Root>
        );
    }
}

const ContentContainer = styled.div`
    padding: 0px 16px;

    width: 100%;
    max-width: 360px;

    ${mediaWidth.m} {
        padding: 0px 48px;

        max-width: 768px;
    }

    ${mediaWidth.l} {
        padding: 0px 64px;

        max-width: 1024px;
    }

    ${mediaWidth.xl} {
        padding: 0px 60px;

        max-width: 1400px;
    }
`;

const Root = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;

    background-color: ${({ backgroundColor }) => backgroundColor};

    /* ${mediaWidth.m} {
        background-color: transparent;
    } */

`;

export default Content;
